import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Platform } from '@angular/cdk/platform';
import { CookieService } from '../../../../../../shared/services/cookie.service';

@Component({
  selector: 'app-thank-modal',
  templateUrl: './thank-modal.component.html',
  styleUrls: ['./thank-modal.component.scss'],
})
export class ThankModalComponent implements OnInit {
  randType = false;

  constructor(
    public activeModal: NgbActiveModal,
    private platform: Platform,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.randType = Math.random() < 0.5;
  }

  close() {
    this.loadModalPwa();
    this.activeModal.dismiss('Cross click');
  }

  private loadModalPwa(): void {
    if (
      !CookieService.getCookie('stic') &&
      !window.matchMedia('(display-mode: standalone)').matches
    ) {
      if (
        this.platform.ANDROID ||
        (this.platform.IOS &&
          this.platform.SAFARI &&
          /^((?!chrome|android).)*safari/i.test(navigator.userAgent))
      ) {
        this.showInstallModal(event, 'ANDROID', () => {
          CookieService.setCookie('stic', false, {
            expires: Date.now() + 1000 * 60 * 60 * 24,
          });
        });
      }

      if (
        this.platform.IOS &&
        this.platform.SAFARI &&
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      ) {
        const isInStandaloneMode =
          'standalone' in window.navigator && (<any>window.navigator).standalone;
        if (!isInStandaloneMode) {
          this.showInstallModal(null, 'IOS', () => {
            CookieService.setCookie('stic', false, {
              expires: Date.now() + 1000 * 60 * 60 * 24,
            });
          });
        }
      }
    }
  }

  private showInstallModal(event: any | null, platform: string, closeCallBack: Function) {
    import('../../../../../../components/modals/modal-install/modal-install-component.module').then(
      ({ ModalInstallComponentModule }) => {
        const ModalInstallComponent = ModalInstallComponentModule.getComponent();
        const installModal = this.modalService.open(ModalInstallComponent);
        installModal.componentInstance.modalPwaEvent = event;
        installModal.componentInstance.modalPwaPlatform = platform;
        installModal.componentInstance.modalClosed.subscribe(closeCallBack);
      },
    );
  }
}
